import { useRef } from "react";

export default function Composer({ value, onChange, onSend, disabled }) {
  const ref = useRef(null);

  const autosize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 140) + "px";
  };

  return (
    <div className="composer-wrap">
      <div className="composer">
        <textarea
          ref={ref}
          id="input"
          rows={1}
          placeholder="Message the assistant…"
          autoComplete="off"
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
            autosize();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              onSend();
            }
          }}
        />
        <button id="send" onClick={onSend} disabled={disabled}>
          Send
        </button>
      </div>
      <div className="hint">The assistant answers only from the dataset · charts and tables render inline</div>
    </div>
  );
}
